import { commonAppActions } from "../../commons/store/actions";

import mobileAppSlice from "./slices/mobile";

export const mobileAppActions = {
  ...commonAppActions,
  mobile: mobileAppSlice.actions
};
